import React from 'react';
import { styled } from '@mui/material/styles';
import shatteredLogo from '../../../image/error_pics/shattered-logo.png'; // Replace this with the path to your logo

const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  textAlign: 'center',
  background: '#ffffff',
});

const LogoContainer = styled('div')({
  marginBottom: '2rem',
});

const Logo = styled('img')({
  width: '225px', // 200px - 250px is a good range
});

const ErrorContent = styled('div')({
  maxWidth: '500px',
});

const ErrorHeading = styled('h1')({
  fontSize: '2.5rem',
  marginBottom: '1rem',
});

const ErrorMessage = styled('p')({
  marginBottom: '2rem',
});

const ErrorLink = styled('a')({
  color: 'blue',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

const ErrorPage = () => (
  <PageContainer>
    <LogoContainer>
      <Logo src={shatteredLogo} alt='Company Logo' />
    </LogoContainer>
    <ErrorContent>
      <ErrorHeading>Oops, something went wrong...</ErrorHeading>
      <ErrorMessage>
        We are sorry for the inconvenience. Our team has been notified and we
        are working to fix the issue.
      </ErrorMessage>
      <ErrorLink href='/'>Go back to home page</ErrorLink>
    </ErrorContent>
  </PageContainer>
);

export default ErrorPage;
